import { EventEmitter } from '../utils/event-emitter';
import {
  UsersIcon,
  SpeechBalloonIcon,
  GalleryIcon,
  RunningSprintIcon,
  SparklesIcon,
  CpuIcon,
  FolderOpenIcon,
  ShoppingBagsGlassIcon,
  CrmIcon,
} from '../icons';

export interface LeanChannel {
  id: string;
  name: string;
  isPrivate: boolean;
  description: string;
}

export const LEAN_CHANNELS: LeanChannel[] = [
  {
    id: 'general',
    name: 'general',
    isPrivate: false,
    description: 'Open decentralized team room',
  },
  {
    id: 'private',
    name: 'private',
    isPrivate: true,
    description: 'Guarded access channel with host admission gate',
  },
];

export interface ChannelCategoryDef {
  id: string;
  name: string;
  description?: string;
  icon: any;
  defaultOpen: boolean;
  channelIds: string[];
}

export const STORAGE_KEY_CHANNEL_CATEGORIES = 'herx_channel_categories_v3';

export const DEFAULT_CLEAN_CATEGORIES: ChannelCategoryDef[] = [
  {
    id: 'community',
    name: 'Channels',
    description: 'Team Channels',
    icon: SpeechBalloonIcon,
    defaultOpen: true,
    channelIds: ['general', 'private'],
  },
];

export const LEGACY_ENTERPRISE_CATEGORIES: ChannelCategoryDef[] = [];

class ChannelAssignmentStore extends EventEmitter {
  private static instance: ChannelAssignmentStore;
  private categories: ChannelCategoryDef[];

  private constructor() {
    super();
    this.categories = this.loadFromStorage();
  }

  public static getInstance(): ChannelAssignmentStore {
    if (!ChannelAssignmentStore.instance) {
      ChannelAssignmentStore.instance = new ChannelAssignmentStore();
    }
    return ChannelAssignmentStore.instance;
  }

  private loadFromStorage(): ChannelCategoryDef[] {
    return DEFAULT_CLEAN_CATEGORIES;
  }

  private persist(): void {
    if (typeof localStorage !== 'undefined') {
      try {
        const serializable = this.categories.map((c) => ({
          id: c.id,
          name: c.name,
          defaultOpen: c.defaultOpen,
          channelIds: c.channelIds,
        }));
        localStorage.setItem(STORAGE_KEY_CHANNEL_CATEGORIES, JSON.stringify(serializable));
      } catch (err) {
        console.warn('[ChannelAssignmentStore] Failed to save categories:', err);
      }
    }
    this.emit('change', this.categories);
  }

  private getIconForCategory(catId: string): any {
    return SpeechBalloonIcon;
  }

  public getCategories(): ChannelCategoryDef[] {
    return [...this.categories];
  }

  public assignChannelToCategory(channelId: string, targetCategoryId: string): void {
    // simplified
  }

  public removeChannel(channelId: string): void {
  }

  public addCategory(name: string): string {
    return name;
  }

  public resetToDefaults(): void {
    this.categories = [...DEFAULT_CLEAN_CATEGORIES];
    this.persist();
  }
}

export const channelAssignmentStore = ChannelAssignmentStore.getInstance();
